import { render } from "./WelcomeScreen.vue?vue&type=template&id=603f3fa7&scoped=true"
import script from "./WelcomeScreen.vue?vue&type=script&lang=js"
export * from "./WelcomeScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=603f3fa7&lang=scss&scoped=true"
import "./WelcomeScreen.vue?vue&type=style&index=1&id=603f3fa7&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603f3fa7"]])

export default __exports__